import { Col, Container, Nav, Row, Form, Button, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaSitemap } from "react-icons/fa";
import { Tooltip } from "antd";
import SwitchTextSize from "./SwitchTextSize";
import { useState, useEffect } from "react";
import { GrYoutube } from "react-icons/gr";
import { FaFacebook } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import { IoDownloadSharp } from "react-icons/io5";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaInstagramSquare } from "react-icons/fa";
import { MdLightMode, MdDarkMode } from "react-icons/md";
import { AiFillSound } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import { Link } from 'react-router-dom'; // Import the Link component
import { FaShareAlt } from "react-icons/fa";
import { FaAccessibleIcon } from "react-icons/fa";
import { MdTranslate } from "react-icons/md";
function SubHeader2() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'hi');
  const [isDarkMode, setIsDarkMode] = useState(localStorage.getItem('theme') === 'dark');

  useEffect(() => {
    i18n.changeLanguage(language);
    document.body.classList.toggle('dark-mode', localStorage.getItem('theme') === 'dark');
  }, [language, i18n]);

  const toggleLanguage = () => {
    const newLanguage = language === 'hi' ? 'en' : 'hi';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  const toggleTheme = () => {
    // const newTheme = isDarkMode ? 'light' : 'dark';
    setIsDarkMode(!isDarkMode);
    // localStorage.setItem('theme', newTheme);
    // document.body.classList.toggle('dark-mode', newTheme === 'dark');
  };

  return (
    <div className="sub-header2">

      <Container fluid="xxl" >
        <Row className="d-flex justify-content-center">
          <Col md={12} lg={12} className="mx-auto">
            <Nav as="ul" className="font-acc m-1 justify-content-evenly">


              {/* Desktop view icons */}
              <div className="d-none ">
                <Nav.Item as="li">
                  <Nav.Link href="https://www.youtube.com/@ccostraipur8046" target="_blank">
                    <GrYoutube style={{ color: "red" }} />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link href="https://www.facebook.com/profile.php?id=61556133871627" target="_blank">
                    <FaFacebook style={{ color: "#3b5998" }} />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link href="https://x.com/CcostRaipur" target="_blank">
                    <FaSquareXTwitter style={{ color: "#000", backgroundColor: "white" }} />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link href="https://www.instagram.com/ccostraipur01/?hl=en" target="_blank">
                    <FaInstagramSquare style={{ color: "rgb(228, 64, 95)" }} />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link href="mailto:dgccost@gmail.com" target="_blank">
                    <BiLogoGmail style={{ color: "#dd4b39" }} />
                  </Nav.Link>
                </Nav.Item>
              </div>

              {/* Mobile view dropdown */}
              <div className="">
                <Dropdown>
                  <Dropdown.Toggle variant="light" id="dropdown-basic" className="social-dropdown">
                    <FaShareAlt size={18} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="social-menu">
                    <Dropdown.Item href="https://www.youtube.com/@ccostraipur8046" target="_blank">
                      <GrYoutube style={{ color: "red", fontSize: "1.3rem" }} />
                    </Dropdown.Item>
                    <Dropdown.Item href="https://www.facebook.com/profile.php?id=61556133871627" target="_blank">
                      <FaFacebook style={{ color: "#3b5998", fontSize: "1.3rem" }} />
                    </Dropdown.Item>
                    <Dropdown.Item href="https://x.com/CcostRaipur" target="_blank">
                      <FaSquareXTwitter style={{ color: "#000", fontSize: "1.3rem" }} />
                    </Dropdown.Item>
                    <Dropdown.Item href="https://www.instagram.com/ccostraipur01/?hl=en" target="_blank">
                      <FaInstagramSquare style={{ color: "rgb(228, 64, 95)", fontSize: "1.3rem" }} />
                    </Dropdown.Item>
                    <Dropdown.Item href="mailto:dgccost@gmail.com" target="_blank">
                      <BiLogoGmail style={{ color: "#dd4b39", fontSize: "1.3rem" }} />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>


              <Nav.Item as="li" >
                <Tooltip placement="bottom" title="Skip to main content">
                  <Nav.Link href="#main-content">
                    <span>
                      <IoDownloadSharp  />
                    </span>
                    <span className="d-none d-xl-inline-block">
                      {t("subHeader.mainContent")}
                    </span>
                  </Nav.Link>
                </Tooltip>
              </Nav.Item>

              <Nav.Item as="li" className="mt-1">
                <Tooltip placement="bottom" title="Sitemap">
                  <Link to="site-map" >
                    <span>
                      <FaSitemap />
                    </span>
                    <span className="d-none d-xl-inline-block">
                      {t("subHeader.sitemap")}
                    </span>
                  </Link>
                </Tooltip>
              </Nav.Item>

              {/* Desktop view icons */}
              <div className="d-none d-md-flex">
                <Nav.Item as="li" className="mt-1">
                  <Tooltip placement="bottom" title="Screen Reader Access">
                    <Link to="/screen-reader-access">
                      <span>
                        <AiFillSound />
                      </span>
                      <span className="d-none d-xl-inline-block">
                        {t("subHeader.screenReader")}
                      </span>
                    </Link>
                  </Tooltip>
                </Nav.Item>
                <SwitchTextSize />
                <Nav.Item as="li">
                  <Tooltip placement="bottom" title={isDarkMode ? "Light Mode" : "Dark Mode"}>
                    <button
                      onClick={toggleTheme}
                    >
                      {isDarkMode ? <MdLightMode /> : <MdDarkMode />}
                    </button>
                  </Tooltip>
                </Nav.Item>
              </div>
              {/* Mobile view dropdown */}
              <div className="d-md-none">
                <Dropdown>
  <Dropdown.Toggle variant="light" id="dropdown-basic" className="social-dropdown">
    <FaAccessibleIcon size={18} />
  </Dropdown.Toggle>

  <Dropdown.Menu className="social-menu">
      <SwitchTextSize />
    {/* Dark Mode Toggle inside Dropdown */}
    <Dropdown.Item as="button" className="d-flex align-items-center" onClick={toggleTheme}>
      {isDarkMode ? <MdLightMode size={18} /> : <MdDarkMode size={18} />}
     
    </Dropdown.Item>

  
    
    
    
  </Dropdown.Menu>
</Dropdown>

              </div>
              <Nav.Item as="li">
                <Tooltip placement="bottom" title={language === 'hi' ? 'In English' : 'हिंदी में'}>
                  <button
                    onClick={toggleLanguage}
                  >
                    <div className="d-none d-md-flex">
                      {language === 'hi' ? 'English' : 'हिंदी'}
                    </div>
                    <div className="d-md-none">
                      <MdTranslate size={18} />
                    </div>
                  </button>
                </Tooltip>
              </Nav.Item>
              {/* <Nav.Item as="li">
                <div className="wrap">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      className="me-2"
                      aria-label="Search"
                    />
                    <Button
                      variant="outline-primary"
                      style={{
                        marginLeft: "-7px"
                      }}
                    >
                      <FaSearch />
                    </Button>
                  </Form>
                </div>
              </Nav.Item> */}

              <Nav.Item as="li">
      <div className="wrap">
        {/* Desktop Search Bar */}
        <div className="d-none d-lg-flex">
          <Form className="d-flex">
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
            />
            <Button
              variant="outline-primary"
              style={{ marginLeft: "-4px" }}
            >
              <FaSearch />
            </Button>
          </Form>
        </div>

        {/* Mobile Search Icon */}
        <div className="d-lg-none">
          {!isSearchOpen ? (
            <Button
              variant="outline-primary"
              onClick={toggleSearch}
            >
              <FaSearch />
            </Button>
          ) : (
            <Form className="d-flex mt-2">
              <Form.Control
                type="search"
                placeholder="Search"
                aria-label="Search"
                autoFocus
              />
              <Button
                variant="outline-primary"
                style={{ marginLeft: "4px" }}
                onClick={toggleSearch}
              >
                <FaSearch />
              </Button>
            </Form>
          )}
        </div>
      </div>
    </Nav.Item>
            </Nav>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SubHeader2;
